export enum PackageType {
  ASURINT = 'ASURINT',
  HIRE_RIGHT = 'HIRE_RIGHT',
  DRIVER_IQ = 'DRIVER_IQ',
}

export const PackageTypeLabels = {
  [PackageType.ASURINT]: 'Asurint',
  [PackageType.HIRE_RIGHT]: 'HireRight',
  [PackageType.DRIVER_IQ]: 'DriverIQ',
}

export const PackageTypeOptions = Object.values(PackageType).map((type) => ({
  value: type,
  label: PackageTypeLabels[type],
}))
